module.exports = __webpack_public_path__ + "static/media/outline-lg-white.01687f16.png";